import React, { Fragment } from 'react'

const EVerifyBanner = () => {
    return (
        <Fragment>
            <div className="container faqbanner homemenu">
                <div className="row">
                    <div className="col-sm-12">
                        <h2>Certificate Verification</h2>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default EVerifyBanner
